import { render, staticRenderFns } from "./CdkColorPicker.vue?vue&type=template&id=7b30e8a1&"
import script from "./CdkColorPicker.vue?vue&type=script&lang=js&"
export * from "./CdkColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./CdkColorPicker.vue?vue&type=style&index=0&postcss=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
